module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0040.jpg?v=7c7ddcc8";